import { render, staticRenderFns } from "./ManageSideForm.vue?vue&type=template&id=f4caec88&scoped=true&"
import script from "./ManageSideForm.vue?vue&type=script&lang=js&"
export * from "./ManageSideForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4caec88",
  null
  
)

export default component.exports